export default __webpack_public_path__ + "static/media/homepage5.25c657e9.jpg";